import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "qa-edit-event-form b-add-edit__form" }
const _hoisted_2 = { class: "b-event-form" }
const _hoisted_3 = { class: "b-add-edit__form--header h-flex h-flex-center h-flex-space-between" }
const _hoisted_4 = { style: {"text-align":"left","width":"100%"} }
const _hoisted_5 = { class: "qa-edit-event-form__title h-font-16 h-m-0 h-text-center" }
const _hoisted_6 = {
  class: "qa-edit-event-form__button__text",
  style: {"text-align":"right","width":"100%"}
}
const _hoisted_7 = { class: "b-add-reserved-slot-form__label" }
const _hoisted_8 = { class: "qa-all-day-title" }
const _hoisted_9 = { class: "b-add-reserved-slot-form__label h-flex-space-between" }
const _hoisted_10 = { class: "qa-date-from-part__title" }
const _hoisted_11 = { class: "h-flex" }
const _hoisted_12 = { class: "h-pos-rel b-calendar-select__week fw-select-base fw-select-base__time h-flex-1-0 h-width-105" }
const _hoisted_13 = {
  key: 0,
  class: "h-pos-rel b-calendar-select__time qa-time-from-part__picker fw-select-base fw-select-base__time h-flex-1-0 h-width-105"
}
const _hoisted_14 = { style: {"max-width":"155px"} }
const _hoisted_15 = { class: "b-add-reserved-slot-form__label h-flex-space-between" }
const _hoisted_16 = { class: "h-flex" }
const _hoisted_17 = {
  key: 0,
  class: "h-pos-rel b-calendar-select__time fw-select-base fw-select-base__time h-flex-1-0 h-width-105"
}
const _hoisted_18 = { class: "b-add-edit__form--required h-font-14 h-fw-500 h-mb-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_AddOrEditEventFormOptions = _resolveComponent("AddOrEditEventFormOptions")!
  const _component_UserFormList = _resolveComponent("UserFormList")!
  const _component_FwHorizontalScroll = _resolveComponent("FwHorizontalScroll")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwSwitcher = _resolveComponent("FwSwitcher")!
  const _component_FwLabelCard = _resolveComponent("FwLabelCard")!
  const _component_FwDatepicker = _resolveComponent("FwDatepicker")!
  const _component_UnavailabilityCategoryFeature = _resolveComponent("UnavailabilityCategoryFeature")!
  const _component_RecurrenceFeature = _resolveComponent("RecurrenceFeature")!
  const _component_RecurrenceEndFeature = _resolveComponent("RecurrenceEndFeature")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FwButton, {
          color: "transparent",
          style: {"color":"#D71254","min-width":"80px"},
          fontSize: "12px",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close")))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('BUTTON.CANCEL')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.isEdit ? _ctx.$t('ADD.EVENT.CHANGE.UNAVAILABILITY.TITLE') : _ctx.$t('ADD.EVENT.ADD.UNAVAILABILITY.TITLE')), 1),
        _createVNode(_component_FwButton, {
          class: _normalizeClass(["qa-edit-event-form__button b-add-edit__form--header-text", { "h-block-for-events": _ctx.isChangeEventRequestSending }]),
          color: "transparent",
          fontSize: "12px",
          disabled: !_ctx.isAddOrEditFormValid || !this.isDayEndValid || !this.isDayStartValid,
          style: {"min-width":"80px","text-align":"right"},
          onClick: _ctx.postEvent
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.isEdit ? _ctx.$t('BUTTON.SAVE') : _ctx.$t('BUTTON.ADD')), 1)
          ]),
          _: 1
        }, 8, ["class", "disabled", "onClick"])
      ]),
      _createElementVNode("form", null, [
        _createVNode(_component_AddOrEditEventFormOptions, {
          title: `${_ctx.$t(`BUTTON.CATEGORY`)}*`,
          optionsData: _ctx.headerOptionsData,
          disabled: _ctx.isFutureEdit,
          onShowComponent: _cache[1] || (_cache[1] = componentName => _ctx.showComponent = componentName)
        }, null, 8, ["title", "optionsData", "disabled"]),
        (!_ctx.isEdit && _ctx.userPermissionOnlyAdmin)
          ? (_openBlock(), _createBlock(_component_FwFormInput, {
              key: 0,
              class: "h-mb-25",
              labelType: "label-thin",
              disabled: _ctx.isFutureEdit,
              title: `${_ctx.$t(`EVENT.FORM.LABEL.ASSIGNED.TO`)}*`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FwHorizontalScroll, {
                  isPageLoaded: true,
                  style: _normalizeStyle(_ctx.scrollStyle),
                  slotWrapperClass: "h-flex h-flex-dir-column h-height-auto-force",
                  iconClass: "h-opacity-1",
                  newClass: "fw-arrow-big-circle",
                  newClassModifier: "fw-arrow-big-circle--middle-size",
                  arrowBgWidth: null,
                  colorIcon: "#fff",
                  btnLocation: "between"
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_UserFormList, {
                      users: _ctx.usersWithoutSites,
                      userFilterId: _ctx.userFilterId,
                      onClick: _ctx.addActiveUser
                    }, null, 8, ["users", "userFilterId", "onClick"])
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            }, 8, ["disabled", "title"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_FwFormInput, {
            class: "h-mb-25 qa-all-day-part",
            fieldHasError: false,
            labelType: "label-thin",
            title: `${_ctx.$t(`EVENT.FORM.LABEL.DURATION`)}*`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FwLabelCard, {
                class: "h-mb-10",
                height: "50px",
                disabled: _ctx.isLimitedEdit,
                padding: "0 20px"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["b-add-reserved-slot-form__label__text", { "b-add-reserved-slot-form__label__text--active": _ctx.allDayIsActive }])
                    }, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('ADD.RESERVED.SLOT.FORM.ALL_DAY')), 1)
                    ], 2),
                    (_ctx.isLimitedEdit)
                      ? (_openBlock(), _createBlock(_component_FwIcon, {
                          key: 0,
                          class: "h-mh-5 b-input-lock-wrapper__icon",
                          icon: "lock",
                          size: "20",
                          color: "#BEC7D3"
                        }))
                      : (_openBlock(), _createBlock(_component_FwSwitcher, {
                          key: 1,
                          isActive: _ctx.allDayIsActive,
                          isRequestSending: false,
                          onToggleSwitch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.allDayIsActive = !_ctx.allDayIsActive))
                        }, null, 8, ["isActive"]))
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_FwLabelCard, {
            class: "h-mv-20 qa-date-from-part",
            height: "50px",
            errorClass: !_ctx.isDayStartValid,
            disabled: _ctx.isLimitedEdit,
            padding: "0 20px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(["b-add-reserved-slot-form__label__text h-uppercase h-mr-10", { "b-add-reserved-slot-form__label__text--active": _ctx.endRecurrenceIsActive }])
                }, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('SETTINGS.CALENDAR.FROM')), 1)
                ], 2),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_FwDatepicker, {
                      modelValue: _ctx.startDay,
                      calendarPanelKey: _ctx.calendarPanelKey,
                      class: "b-add-reserved-slot-form__day_datepicker qa-date-from-part__picker",
                      name: "datepicker",
                      propsRange: false,
                      selectMode: false,
                      disabled: _ctx.disableStartDay || _ctx.isLimitedEdit || _ctx.isFutureEdit,
                      propsLang: `${_ctx.$i18n.locale}`,
                      propsFormat: "DD MMM YY",
                      hideIcon: true,
                      pickerStyle: "form",
                      iconName: "arrow-bottom",
                      iconSize: "10",
                      customArrowColor: true,
                      iconRight: true,
                      disabledDate: _ctx.disabledDateByObjectStartDay,
                      defaultValue: _ctx.date,
                      propsInputClass: "h-text-center",
                      onSelectDate: _ctx.changeEndDate
                    }, {
                      icon: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("   ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue", "calendarPanelKey", "disabled", "propsLang", "disabledDate", "defaultValue", "onSelectDate"])
                  ]),
                  (!_ctx.allDayIsActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_FwDatepicker, {
                            modelValue: _ctx.timeFrom,
                            name: "datepicker",
                            propsType: "time",
                            disabled: _ctx.isLimitedEdit,
                            placeholder: "HH:mm",
                            propsRange: false,
                            selectMode: false,
                            propsLang: `${_ctx.$i18n.locale}`,
                            propsFormat: _ctx.timeFormat,
                            hideIcon: true,
                            editStatus: true,
                            disabledTime: _ctx.lunchIntervalTime,
                            pickerStyle: "time",
                            iconSize: "0",
                            iconRight: false,
                            propsInputClass: "h-text-center",
                            propsTimePickerOptions: _ctx.timeSiteStart,
                            onSelectDate: _cache[3] || (_cache[3] = value => _ctx.timeFrom = value)
                          }, null, 8, ["modelValue", "disabled", "propsLang", "propsFormat", "disabledTime", "propsTimePickerOptions"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLimitedEdit)
                    ? (_openBlock(), _createBlock(_component_FwIcon, {
                        key: 1,
                        class: "h-mh-5 b-input-lock-wrapper__icon",
                        icon: "lock",
                        size: "20",
                        color: "#BEC7D3"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["errorClass", "disabled"]),
          _createVNode(_component_FwLabelCard, {
            class: "h-mv-20",
            height: "50px",
            errorClass: !_ctx.isDayEndValid,
            padding: "0 20px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: _normalizeClass(["b-add-reserved-slot-form__label__text h-uppercase h-mr-10", { "b-add-reserved-slot-form__label__text--active": _ctx.endRecurrenceIsActive }])
                }, _toDisplayString(_ctx.$t('SETTINGS.CALENDAR.TO')), 3),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ "b-calendar-select--disable": _ctx.disableEndDay }, "h-pos-rel b-calendar-select__week fw-select-base fw-select-base__time h-flex-1-0 h-width-105"])
                  }, [
                    _createVNode(_component_FwDatepicker, {
                      modelValue: _ctx.endDay,
                      class: "b-add-reserved-slot-form__day_datepicker",
                      calendarPanelKey: _ctx.calendarPanelKey,
                      disabled: _ctx.disableEndDay || _ctx.isLimitedEdit || _ctx.isFutureEdit,
                      name: "datepicker2",
                      propsLang: `${_ctx.$i18n.locale}`,
                      propsRange: false,
                      selectMode: false,
                      propsFormat: "DD MMM YY",
                      hideIcon: true,
                      pickerStyle: "form",
                      iconName: "arrow-bottom",
                      iconSize: "10",
                      customArrowColor: true,
                      iconRight: true,
                      disabledDate: _ctx.disabledDateByObjectEndDay,
                      defaultValue: _ctx.date,
                      propsInputClass: "h-text-center",
                      onSelectDate: _cache[4] || (_cache[4] = value => _ctx.endDay = value)
                    }, {
                      icon: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("   ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue", "calendarPanelKey", "disabled", "propsLang", "disabledDate", "defaultValue"])
                  ], 2),
                  (!_ctx.allDayIsActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_FwDatepicker, {
                          modelValue: _ctx.timeTo,
                          name: "datepicker",
                          propsType: "time",
                          placeholder: "hh:mm",
                          propsRange: false,
                          selectMode: false,
                          propsLang: `${_ctx.$i18n.locale}`,
                          propsFormat: _ctx.timeFormat,
                          hideIcon: true,
                          editStatus: true,
                          disabledTime: _ctx.lunchIntervalTime,
                          pickerStyle: "time",
                          iconSize: "0",
                          iconRight: false,
                          propsInputClass: "h-text-center",
                          propsTimePickerOptions: _ctx.timeSiteEnd,
                          onSelectDate: _cache[5] || (_cache[5] = value => _ctx.timeTo = value)
                        }, null, 8, ["modelValue", "propsLang", "propsFormat", "disabledTime", "propsTimePickerOptions"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLimitedEdit)
                    ? (_openBlock(), _createBlock(_component_FwIcon, {
                        key: 1,
                        class: "h-mh-5 b-input-lock-wrapper__icon",
                        icon: "edit",
                        size: "20",
                        color: "#BEC7D3"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["errorClass"])
        ]),
        _createVNode(_component_AddOrEditEventFormOptions, {
          title: _ctx.$t("EVENT.FORM.LABEL.OPTIONS"),
          optionsData: _ctx.optionsData,
          disabled: _ctx.isFutureEdit,
          onShowComponent: _cache[6] || (_cache[6] = componentName => _ctx.showComponent = componentName)
        }, null, 8, ["title", "optionsData", "disabled"])
      ]),
      _createElementVNode("p", _hoisted_18, " *" + _toDisplayString(_ctx.$t(`EVENT.FORM.LABEL.REQUIRED`)), 1)
    ], 512), [
      [_vShow, !_ctx.showComponent]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_FwIcon, {
        class: "b-add-edit__form__back-arrow",
        icon: "arrow-left",
        size: "10",
        color: "#213F6B",
        onClick: _ctx.showMainForm
      }, null, 8, ["onClick"]),
      (_ctx.showUnavailabilityCategoryFeature)
        ? (_openBlock(), _createBlock(_component_UnavailabilityCategoryFeature, {
            key: 0,
            categories: _ctx.categories,
            activeIndex: _ctx.categoryIndex,
            onSetCategoryIndex: _ctx.setCategoryIndex
          }, null, 8, ["categories", "activeIndex", "onSetCategoryIndex"]))
        : _createCommentVNode("", true),
      (_ctx.showRecurrenceFeature)
        ? (_openBlock(), _createBlock(_component_RecurrenceFeature, {
            key: 1,
            dayList: _ctx.dayList,
            recurrenceList: _ctx.recurrenceList,
            recurrence: _ctx.recurrence,
            weekIndex: _ctx.weekIndex,
            weekIndexOptions: _ctx.weekIndexOptions,
            onSetRecurrence: _ctx.setRecurrence
          }, null, 8, ["dayList", "recurrenceList", "recurrence", "weekIndex", "weekIndexOptions", "onSetRecurrence"]))
        : _createCommentVNode("", true),
      (_ctx.showRecurrenceEndFeature)
        ? (_openBlock(), _createBlock(_component_RecurrenceEndFeature, {
            key: 2,
            endRecurrenceDate: _ctx.endRecurrenceDate,
            onSetRecurrenceEnd: _ctx.setRecurrenceEnd
          }, null, 8, ["endRecurrenceDate", "onSetRecurrenceEnd"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.showComponent]
    ])
  ]))
}